<template>
    <div class="mobile-table-container">
        <template v-if="sortableFields.length !== 0 && isSetFilter === true">
            <div class="mobile-table-header">
                <div class="row">
                    <div class="col col-filter col-sm" @click="openedFilter = !openedFilter">
                        <div class="col-filter-content">
                            <small class="d-block">{{t('Search')}}</small>
                            <span class="d-block" v-if="activeFiltersCount === 0">{{t('Filter is disabled')}}</span>
                            <span class="d-block" v-if="activeFiltersCount !== 0">{{t('Filter is active')}}</span>
                        </div>
                    </div>
                    <div class="col col-filter col-sm"
                         v-on:click="currentSortColumn === null ? '' : setSortable(currentSortColumn)"
                         v-if="currentSortColumn !== null"
                    >
                        <div class="col-filter-content">
                            <small class="d-block">{{t('Sort by')}}</small>
                            <span class="d-block">
                            {{currentSortColumn.name}}
                            <font-awesome-icon icon="sort-up" v-if="sortable.direction === 'ASC'"/>
                            <font-awesome-icon icon="sort-down" v-if="sortable.direction === 'DESC'"/>
                        </span>
                        </div>
                    </div>
                    <div class="col col-sm col-filter-cog" @click="openedFilter = !openedFilter">
                        <div class="col-button">
                            <font-awesome-icon icon="cog"/>
                        </div>
                    </div>
                </div>
            </div>

            <div class="mobile-table-filters mb-3" :class="{'d-none': openedFilter === false}">
                <div class="mobile-table-filters-item" v-if="sortableFields.length !== 0">
                    <label class="d-block mb-1">{{t('Sort by')}}</label>
                    <button v-for="column in sortableFields"
                            type="button"
                            class="btn btn-sm mb-1 mr-1"
                            :class="{'btn-success': column.key === sortable.key, 'btn-outline-secondary': column.key !== sortable.key}"
                            v-on:click="setSortable(column)"
                    >
                        {{column.name}}
                        <template v-if="column.key === sortable.key">
                            <font-awesome-icon icon="sort-up" v-if="sortable.direction === 'ASC'"/>
                            <font-awesome-icon icon="sort-down" v-if="sortable.direction === 'DESC'"/>
                        </template>
                    </button>
                </div>

                <template v-if="isSetFilter === true">
                    <div class="mobile-table-filters-item" v-for="column in columns" v-if="column.filter !== undefined">
                        <label class="d-block mb-1">{{column.name}}</label>
                        <grid-filter :settings="column.filter"
                                     :column="column"
                                     v-on:changed="setConditions(column, $event)"
                                     v-on:removed="resetFilter(column)"
                        />
                    </div>
                </template>

                <div class="mobile-table-filters-item" @click="openedFilter = false">
                    <button type="button" class="btn btn-primary btn-sm mr-1">
                        {{t('Apply')}}
                    </button>
                    <button type="button"
                            class="btn btn-outline-secondary btn-sm mr-1"
                            @click="openedFilter = false; $emit('onFilter', {})"
                    >
                        {{t('Reset')}}
                    </button>
                </div>
            </div>
        </template>

        <table class="table table-mobile" v-if="openedFilter === false">
            <tbody>
            <tr v-if="loading === false & items.length === 0">
                <td :colspan="buttons.length === 0 ? 1 : 2" class="text-center p-3">
                    {{t('No items found')}}
                </td>
            </tr>
            <tr v-if="loading === true">
                <td :colspan="buttons.length === 0 ? 1 : 2" class="text-center p-3">
                    <loading size="xs"/>
                    {{t('Loading')}}
                </td>
            </tr>
            <tr v-for="item in items" v-if="loading === false" :class="getRowClass(item)">
                <td>
                    <template v-for="(column, index) in columns">
                        <div class="table-heading">{{column.name}}</div>
                        <div class="table-body">
                            <slot :name="column.key" v-bind:item="item"></slot>
                        </div>
                    </template>

                </td>
                <td class="actions text-center align-middle" v-on:click="options = item.id" v-if="buttons.length !== 0">
                    <slot name="before-actions" :item="item"></slot>
                    <buttons class="table-options"
                             v-on:button="$emit('buttonEvent', {item: item, event: $event})"
                             :data="item"
                             :buttons="buttons"
                    />
                    <slot name="after-actions" :item="item"></slot>
                </td>
            </tr>
            </tbody>
        </table>
    </div>
</template>
<script>
    import {table} from './Table';
    import Loading from '../../Components/loading';

    export default {
        mixins: [table],
        components: {Loading},
        props: {},
        computed: {
            activeFiltersCount() {
                return Object.keys(this.conditions).length;
            },
            sortableFields() {
                return this.columns.filter(column => {
                    return this.isSortable(column) === true;
                });
            },
            currentSortColumn() {
                const found = this.columns.find(item => {
                    return item.key === this.sortable.key;
                });
                return found === undefined ? null : found;
            }
        },
        methods: {
            getColumnClass(column, index) {
                let styleClass = 'titan-grid-column-' + column.key;
                if (this.activeColumn === index) {
                    styleClass += ' activeColumn';
                }
                if (column.scrollable === true) {
                    styleClass += ' scrollable';
                }
                return styleClass;
            },
        },
        data() {
            return {
                openedFilter: false,
            };
        }
    }
</script>
<style lang="scss">
    .mobile-table-container {
        .mobile-table-filters {
            background: #fff;

            .mobile-table-filters-item {
                border-top: 2px solid #eff1f4;
                padding: 7px;
            }

            .col-filter-cog {
                max-width: 90px;
            }

            .multiselect__tags,
            .date-range-label {
                border: 1px solid #ced4da;
                border-radius: 0.2rem;
            }
        }

        .mobile-table-header {
            background: #F5F7F8;

            .col-text {
                padding: 8px;
            }
        }

        .col-button {
            border-left: 2px solid #eff1f4;
            background: rgba(255, 255, 255, .4);
            padding: 7px;
            text-align: center;
            color: #787e86;
            width: 100%;
        }

        .col-filter {
            .col-filter-content {
                padding: 5px 8px;

                small {
                    line-height: 13px;
                    font-size: 12px;
                    color: #9fa0a2;
                }

                span {
                    line-height: 14px;
                }
            }
        }

        table.table-mobile {
            background: #fff;
            table-layout: fixed;

            td {
                font-size: 15px;
                line-height: 17px;
                border-color: #EFF1F4;

                transition: background .4s;
                border-top-width: 2px;
                border-right: 1px solid #EFF1F4;
                vertical-align: middle;
                padding: 8px;

                .table-heading {
                    font-size: 12px;
                    line-height: 13px;
                    opacity: 0.5;
                }

                .table-body {
                    margin-bottom: 5px;
                }

                .table-options {
                    text-align: left;
                    display: block;

                    .btn {
                        display: block;
                        margin: 0 auto 5px 0;
                        white-space: nowrap;
                        padding: 3px 7px;
                        font-size: 12px;
                    }
                }

                &.actions {
                    width: 100px;
                    white-space: nowrap;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/core/InlineDataGrid/tables/Mobile.vue